/* eslint-disable @typescript-eslint/no-namespace */
export interface ITealiumWindow extends Window {
  utag?: ITagManager;
}

export interface ITagManager {
  data?: {
    [name: string]: string;
  };
  cfg?: {
    [domain: string]: string;
  };
  gdpr?: Tealium.Compliance.Layer;
}

export namespace Tealium{

  export namespace Compliance {
    export type Layer = {
      getCategories(): string[]; 
      setAllCategories(arg0: boolean): void;
      getConsentState(): (0|1|false); 
      consent_prompt: {
        noShow: boolean;
        isEnabled: boolean;
      };
      setPreferencesValues(categories: SelectedCategories): void;
    };
  
    export enum State {
      Off = '0',
      On = '1',
    }
  
    export class SelectedCategories {
      public '1' = State.Off;
      public '2' = State.Off;
      public '3' = State.Off;
      public '4' = State.Off;
      public '5' = State.Off;
      public '6' = State.Off;
      public '7' = State.Off;
      public '8' = State.Off;
      public '9' = State.Off;
      public '10' = State.Off;
      public '11' = State.Off;
      public '12' = State.Off;
      public '13' = State.Off;
      public '14' = State.Off;
      public '15' = State.Off;
    }
  }
}

